import { handleActions } from "redux-actions";

import {
  SET_ERROR,
  SET_MESSAGE,
  SET_LOADING,
  FETCH_CONVERSATIONS_SUCCESS,
  FETCH_SESSION_SUCCESS,
  SEND_FEEDBACK_SUCCESS,
  FETCH_HISTORY_SUCCESS,
  RESET_CHAT
} from "./AISagas";

export const initialState = {
  isLoading: true,
  initialRequest: true,
  status: "idle",
  errors: null,
  conversations: [],
  currentSession: {
    messages: [],
    questions: []
  }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [FETCH_CONVERSATIONS_SUCCESS]: (state, action) => ({
      ...state,
      conversations: action.payload
    }),
    [FETCH_SESSION_SUCCESS]: (state, { payload }) => ({
      ...state,
      currentSession: payload,
      initialRequest: false
    }),
    [SEND_FEEDBACK_SUCCESS]: (state, { payload }) => {
      const { id, feedback } = payload;
      return {
        ...state,
        currentSession: {
          ...state.currentSession,
          messages: state.currentSession.messages.map((msg) =>
            msg.id === id ? { ...msg, feedback } : msg
          )
        }
      };
    },
    [SET_MESSAGE]: (state, { payload }) => {
      if (payload.session_id !== state.currentSession.session_id) {
        return state;
      }

      return {
        ...state,
        currentSession: {
          ...state.currentSession,
          messages: [...state.currentSession.messages, payload],
          questions: payload.questions || state.currentSession.questions
        }
      };
    },
    [RESET_CHAT]: (state) => ({
      ...initialState,
      conversations: state.conversations
    }),
    [FETCH_HISTORY_SUCCESS]: (state, action) => ({
      ...state,
      currentSession: action.payload,
      initialRequest: false
    })
  },

  initialState
);
